import { makeAutoObservable } from 'mobx';
import { TagCondition, createTagCondition } from './TagCondition';

export type ParamCondition = {
  tagCondition: TagCondition;
  params: Record<string, any>;
  setParam(paramName: string, value?: any): void;
  removeParam(paramName: string): void;
  copy(): ParamCondition;
};

export function createParamCondition(json?: Partial<ParamCondition>): ParamCondition {
  return makeAutoObservable({
    tagCondition: createTagCondition(json?.tagCondition),
    params: json?.params ?? {},

    setParam(paramName: string, value?: any) {
      this.params[paramName] = value;
    },

    removeParam(paramName: string) {
      delete this.params[paramName];
    },

    copy(): ParamCondition {
      return createParamCondition(this);
    },
  });
}
